import { put, call, select, takeLatest } from "redux-saga/effects";
import { getAvailableVaccines, getPrefilledData, getAvailableDateTimes, bookInhomeAppointment, getVaccineQuestionnaires, getCovidVaccineQuestionnaires, putVaccineQuestionnaires, validateZipCode } from "../api/inHomeApi";
import * as types from "../constants/actionTypes";
import * as Tools from "../helpers/Tools"
import { logAPI } from "../api/andyliticsApi";
import { isEqual, valuesIn } from 'lodash';

export default function* inHomeSaga() {
    yield takeLatest(types.CHECK_GET_INHOME_PREFILL, getPrefillData);
    yield takeLatest(types.VALIDATE_INHOME_ZIPCODE, validateInHomeZipCode);
    yield takeLatest(types.GET_INHOME_VACCINES, getInHomeVaccines);
    yield takeLatest(types.GET_INHOME_APPTS, getInHomeApptDateTimes);
    yield takeLatest(types.BOOK_INHOME_APPT, bookAppointment);
    yield takeLatest(types.GET_INHOME_ELIGIBILITY_Q, getQuestionnaires);
    yield takeLatest(types.GET_INHOME_ELIGIBILITY_COVID_Q, getCovidQuestionnaires);
    yield takeLatest(types.SEND_INHOME_ELIGIBILITY_RESPONSES, sendQuestionnaires);
}

export function* getPrefillData(data) {
    let mrn = null;
    const start = new Date()
    // old default value was [{ label: "Dallas", value: "dallas" }, { label: "Forth Worth", value: "fort worth" }, { label: "Irving", value: "irving" }, { label: "Plano", value: "plano" }]
    const inHomeCitiesDefault = window.serverData?.data?.inHomeCitiesDefault ? window.serverData.data.inHomeCitiesDefault.split(",").map(city => { return { label: city, value: city.toLowerCase() } }) : [];
    try {
        const previouslySelectedUsers = yield select((state) => state.inHome.selectedUsers)
        const domain = yield select((state) => state.domain);
        const selectedUsers = data.selectedUsers;

       
        if (selectedUsers?.length > 0) {
            mrn = selectedUsers[0].patient?.AMRN;

            if (mrn) {
                yield put({ type: types.GET_INHOME_PREFILL })
                const prefillResponse = yield call(getPrefilledData, mrn, domain.t);
                const address = prefillResponse.addresses && prefillResponse.addresses[0] || {};
                const cities = prefillResponse.cities && prefillResponse.cities.length ? prefillResponse.cities.map(city => { return { label: city, value: city.toLowerCase() } }) : inHomeCitiesDefault
                const insurance_types = prefillResponse.insurance_types && prefillResponse.insurance_types.length ? prefillResponse.insurance_types.map(insuranceType => { return { label: insuranceType, value: insuranceType } }) : {}
                const prefillData = {
                    address1: address.address1 || '',
                    address2: address.address2 || '',
                    city: address.city,
                    state: address.state || 'TX',
                    zipCode: address.zip_code,
                    email: prefillResponse.email,
                    mobilePhone: prefillResponse.mobile_phone ? Tools.ciReplace(prefillResponse.mobile_phone, "-", ".") : '', //mobile phone comes in with dashes
                    languages: prefillResponse.languages || [{ key: "en", value: "English" }, { key: "ko", value: "Korean" }, { key: "es", value: "Spanish" }],
                    cities: cities,
                    preferredLanugage: prefillResponse.preferred_language || "en",
                    insurance_types: insurance_types
                }
                if (data) {
                    logAPI("MBHWeb.Saga.InHome.GetPrefill", start, null);
                    yield put({ type: types.GET_INHOME_PREFILL_RESULT, data: prefillData })
                } else {
                    logAPI("MBHWeb.Saga.InHome.GetPrefill.Failure", start, null);
                    let prefillData = {
                        address1: '',
                        address2: '',
                        city: '',
                        state: 'TX',
                        zipCode: '',
                        email: '',
                        mobilePhone: '',
                        languages: [{ key: "en", value: "English" }, { key: "ko", value: "Korean" }, { key: "es", value: "Spanish" }],
                        preferredLanugage: "en",
                        cities: inHomeCitiesDefault
                    }
                    yield put({ type: types.GET_INHOME_PREFILL_RESULT, data: prefillData })
                }
            }
        }
    } catch (err) {
        console.log(err);
        let prefillData = {
            address1: '',
            address2: '',
            city: '',
            state: 'TX',
            zipCode: '',
            email: '',
            mobilePhone: '',
            languages: [{ key: "en", value: "English" }, { key: "ko", value: "Korean" }, { key: "es", value: "Spanish" }],
            preferredLanugage: "en",
            cities: inHomeCitiesDefault
        }
        yield put({ type: types.GET_INHOME_PREFILL_RESULT, data: prefillData })
        logAPI("MBHWeb.Saga.InHome.GetPrefill.Failure", start, null, err);
    }
}


export function* getInHomeVaccines(data) {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const serviceLocation = inHomeState.serviceLocationContactInfo;
        const users = inHomeState.selectedUsers;
        const domain = yield select((state) => state.domain);
        const mrnList = users.reduce((acc, curr) => {
            acc.push({'patient_mrn':curr.mrn,'patient_insurance':curr.insurance})
            return acc
        }, [])
        const body = {
            city: serviceLocation.city,
            state_code: serviceLocation.state,
            zip_code: serviceLocation.zipCode,
            userid: domain.ui,
            patients: mrnList
        }
        const response = yield call(getAvailableVaccines, body, domain.t);

        if (response) {
            //create standard js response in camelCase
            let users = []
            response.map((user) => {
                return {
                    ...user,
                    mrn: user.mrn,
                    firstName: user.first_name,
                    lastName: user.last_name,
                    dob: user.dob,
                    vaccines: user.vaccines?.map((vacc) => {
                        return {
                            axleName: vacc.name,
                            displayName: vacc.display_name,
                            axleServiceId: vacc.axle_service_id

                        }
                    })

                }
            })
            result.data = response;
            result.success = true;
            yield put({ type: types.GET_INHOME_VACCINES_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccines", start, null);
        } else {
            result.errorMsg = 'error';
            result.success = false;
            yield put({ type: types.GET_INHOME_VACCINES_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccines.Failure", start, null);
        }

    } catch (err) {
        console.log(err);
        result.errorMsg = err.message;
        result.success = false;
        yield put({ type: types.GET_INHOME_VACCINES_RESULT, data: result })
        logAPI("MBHWeb.Saga.InHome.GetVaccines.Failure", start, null, err);
    }
}


export function* validateInHomeZipCode(payload) {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const serviceLocation = inHomeState.serviceLocationContactInfo;
       
        const domain = yield select((state) => state.domain);
        
        const body = {
            city: serviceLocation.city,
            state_code: serviceLocation.state,
            zip_code: payload.zipCode || serviceLocation.zipCode                    
        }
        const response = yield call(validateZipCode, body, domain.t);

        if (typeof response !== 'object' && response !== null) {
           
            result.data = response;
            result.success = true;
            yield put({ type: types.SET_VALIDATE_INHOME_ZIPCODE_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.ValidateInHomeZipCode", start, null);
        } else {
            result.errorMsg = 'error';
            result.success = false;
            yield put({ type: types.SET_VALIDATE_INHOME_ZIPCODE_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.ValidateInHomeZipCode.Failure", start, null);
        }

    } catch (err) {
        console.log(err);
        result.errorMsg = err.message;
        result.success = false;
        yield put({ type: types.SET_VALIDATE_INHOME_ZIPCODE_RESULT, data: result })
        logAPI("MBHWeb.Saga.InHome.ValidateInHomeZipCode.Failure", start, null, err);
    }
}


export function* getInHomeApptDateTimes() {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const serviceLocation = inHomeState.serviceLocationContactInfo || {};
        const selectedVaccines = inHomeState.selectedVaccines;
        const covidServiceResults = inHomeState.covidServiceResults;  //conatins covid questionnaire results, axle_service_names etc
        const vaccineServiceIds = [];
        selectedVaccines.forEach((user) => {
            user.vaccines_groups.forEach((group) => {
                group.vaccines.forEach((vaccine) => {
                    if (vaccine.isChecked && !vaccine.name.toLowerCase().includes('covid')) //push only non-covid vaccine service ids. For covid we need to provide axle-service-names
                    { vaccineServiceIds.push(vaccine.axle_id) }
                    else if (vaccine.isChecked && vaccine.name.toLowerCase().includes('covid')) { 
                        let userCovidResult = covidServiceResults?.find(covResult => covResult.mrn === user.mrn);
                        if (userCovidResult)
                        vaccineServiceIds.push(userCovidResult?.axle_service_name);
                    }
                })
            })
        })
        /*covidServiceResults?.forEach((covidResult) => {
             //push the axle service names for covid vaccine, instead of the axle-service-ids
            if (covidResult) vaccineServiceIds.push(covidResult?.axle_service_name); 
               
        })*/

        console.log("In InHome Sage, request body for Appointment Slots ", vaccineServiceIds);
        const domain = yield select((state) => state.domain);
        const body = {
            zip_code: serviceLocation.zipCode,
            service_ids: vaccineServiceIds || []
        }
        const response = yield call(getAvailableDateTimes, body, domain.t);


        if (response) {
            // this is saved as is into state
            // shape of response = { availability: [ { date: "YYY-MM-DD", slots: ["YYYY-MM-DDTHH:MM:SS-06:00"] } ] }

            result.data = response.availability;
            result.success = true;
            yield put({ type: types.GET_INHOME_APPTS_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccineApptTimes", start, null);
        } else {
            result.errorMsg = 'error';
            result.success = false;
            yield put({ type: types.GET_INHOME_APPTS_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccineApptTimes.Failure", start, null);
        }

    } catch (err) {
        console.log(err);
        result.errorMsg = err.message;
        result.success = false;
        yield put({ type: types.GET_INHOME_APPTS_RESULT, data: result })
        logAPI("MBHWeb.Saga.InHome.GetVaccineApptTimes.Failure", start, null, err);
    }
}

export function* bookAppointment() {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const serviceLocation = inHomeState.serviceLocationContactInfo || {};
        const selectedVaccines = inHomeState.selectedVaccines;
        const selectedDateTime = inHomeState.selectedDateTime;
        const covidServiceResults = inHomeState.covidServiceResults;  //conatins covid questionnaire results, axle_service_names etc
        const domain = yield select((state) => state.domain);

        const extractFirstUser = selectedVaccines.find((user) => !!user.vaccines_groups.find(group => !!group.vaccines.find(vaccines => !!vaccines.isChecked)))

        const vaccineList = [];
        extractFirstUser.vaccines_groups.forEach((group) => {
            group.vaccines.forEach((curr) => {
                if (curr.isChecked && !curr.name.toLowerCase().includes('covid')) //push only non-covid vaccine service ids. For covid we need to provide axle-service-names
                    vaccineList.push({ axle_service_id: curr.axle_id, axle_vaccine_name: curr.name });

                else if (curr.isChecked && curr.name.toLowerCase().includes('covid')) {
                    //check if primary user has selected a covid vaccine
                    let primaryUserCovidResult = covidServiceResults?.find(covResult => covResult.mrn === extractFirstUser.mrn);
                    if (primaryUserCovidResult)
                        vaccineList.push({ axle_service_id: primaryUserCovidResult?.axle_service_name, axle_vaccine_name: primaryUserCovidResult?.axle_service_name, questionnaire_id: primaryUserCovidResult?.questionnaire_id });
                }
            })

        })



        let updatedMobilePhone = serviceLocation.mobilePhone.replaceAll(".", "-");

        const primary_visit = {
            "mrn": extractFirstUser.mrn,
            "address1": serviceLocation.address1,
            "address2": serviceLocation.address2,
            "city": serviceLocation.city,
            "state": serviceLocation.state,
            "zip_code": serviceLocation.zipCode,
            "mobile_phone": updatedMobilePhone,
            "email": serviceLocation.email,
            "preferred_language": serviceLocation.language,
            "visit_datetime": selectedDateTime,
            "provider_notes": serviceLocation.extraNote,
            "is_self_pay": true,
            "vaccines": vaccineList
        }

        const additional_patients = [];
        selectedVaccines.forEach((item) => {
            if (item.mrn !== extractFirstUser.mrn) {
                let vaccineList = [];
                item.vaccines_groups.forEach((group) => {
                    group.vaccines.forEach((curr) => {
                        if (curr.isChecked && !curr.name.toLowerCase().includes('covid')) //push only non-covid vaccine service ids. For covid we need to provide axle-service-names)
                            vaccineList.push({ axle_service_id: curr.axle_id, axle_vaccine_name: curr.name })
                        else if (curr.isChecked && curr.name.toLowerCase().includes('covid')) {
                            //check if each user has selected a covid vaccine
                            let additionalUserCovidResult = covidServiceResults?.find(covResult => covResult.mrn === item.mrn);
                            if (additionalUserCovidResult)
                                vaccineList.push({ axle_service_id: additionalUserCovidResult?.axle_service_name, axle_vaccine_name: additionalUserCovidResult?.axle_service_name, questionnaire_id: additionalUserCovidResult?.questionnaire_id });

                        }
                    })
                })


                if (vaccineList.length > 0) additional_patients.push({ mrn: item.mrn, vaccines: vaccineList })
            }
        })

        const body = { primary_visit: primary_visit, additional_patients: additional_patients }
        console.log("Inn Inhome Saga, BookAppointment request payload is ", body);

        const response = yield call(bookInhomeAppointment, body, domain.t);
        //let response = {};

        if (response) {
            result.data = response;
            result.success = true;
            yield put({ type: types.BOOK_INHOME_APPT_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.BookAppointment", start, null);
        } else {
            result.errorMsg = "error";
            result.success = false;
            yield put({ type: types.BOOK_INHOME_APPT_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.BookAppointment.Failure", start, null);
        }

    } catch (err) {
        console.log(err);
        result.success = false;
        result.errorMsg = err.message
        logAPI("MBHWeb.Saga.InHome.BookAppointment.Failure", start, null, err);
        yield put({ type: types.BOOK_INHOME_APPT_RESULT, data: result })
    }
}


export function* getCovidQuestionnaires(payload) {
    //console.log("In saga getCovidQuestionnaires, payload ", payload);
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const selectedVaccines = inHomeState.selectedVaccines;
        const selectedUsers = inHomeState.selectedUsers;        
        const domain = yield select((state) => state.domain);

        const response = yield call(getCovidVaccineQuestionnaires, payload.covidQuestionnaireUrl, domain.t);

        //console.log("In InHomeSaga...getCovidQuestionnaire...response", response);

        if (response) {

            let processedData = response;            

            result.data = processedData;
            result.success = true;
            yield put({ type: types.GET_INHOME_ELIGIBILITY_COVID_Q_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetCovidQuestionnaires", start, null);
        } else {
            result.errorMsg = 'error';
            result.success = false;
            yield put({ type: types.GET_INHOME_ELIGIBILITY_COVID_Q_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetCovidQuestionnaires.Failure", start, null);
        }
    } catch (err) {
        console.log(err);
        result.errorMsg = err.message;
        result.success = false;
        yield put({ type: types.GET_INHOME_ELIGIBILITY_COVID_Q_RESULT, data: result })
        logAPI("MBHWeb.Saga.InHome.GetCovidQuestionnaires.Failure", start, null, err);
    }
}

export function* getQuestionnaires() {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const selectedVaccines = inHomeState.selectedVaccines;
        const selectedUsers = inHomeState.selectedUsers;
        const domain = yield select((state) => state.domain);

        const allPatients = [];

        selectedVaccines.forEach((user) => {
            let selectedVax = [];
            user.vaccines_groups.forEach((group) => {
                group.vaccines.forEach((vaccine) => {
                    if (vaccine.isChecked) { selectedVax.push(vaccine.name) }
                })
            })

            if (!selectedVax.length) return

            let extractUser = selectedUsers.find((vax) => {
                return vax.mrn === user.mrn
            })

            let patient = {}

            patient.patient_first_name = extractUser.firstName;
            patient.patient_last_name = extractUser.lastName;
            patient.patient_dob = extractUser.dob;
            patient.patient_mrn = extractUser.mrn;
            patient.vaccine_names = selectedVax;

            allPatients.push(patient)
        })

        const body = [...allPatients];
        const response = yield call(getVaccineQuestionnaires, body, domain.t);

        if (response) {
            //create standard js response in camelCase
            let processedData = response.map((pt) => {
                return {
                    dictionary: pt.dictionary,
                    patient: {
                        dob: pt.patient.dob,
                        mrn: pt.patient.mrn,
                        firstName: pt.patient.first_name,
                        lastName: pt.patient.last_name,
                    },
                    questions: pt.questions.map((q) => {
                        return {
                            items: q.items,
                            vaccineName: q.vaccine_name
                        }
                    })
                }
            })

            result.data = processedData;
            result.success = true;
            yield put({ type: types.GET_INHOME_ELIGIBILITY_Q_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccineQuestionnaires", start, null);
        } else {
            result.errorMsg = 'error';
            result.success = false;
            yield put({ type: types.GET_INHOME_ELIGIBILITY_Q_RESULT, data: result })
            logAPI("MBHWeb.Saga.InHome.GetVaccineQuestionnaires.Failure", start, null);
        }
    } catch (err) {
        console.log(err);
        result.errorMsg = err.message;
        result.success = false;
        yield put({ type: types.GET_INHOME_ELIGIBILITY_Q_RESULT, data: result })
        logAPI("MBHWeb.Saga.InHome.GetVaccineQuestionnaires.Failure", start, null, err);
    }
}


export function* sendQuestionnaires(data) {
    const start = new Date()
    let result = { data: null, success: false, errorMsg: null }

    try {
        const inHomeState = yield select((state) => state.inHome)
        const selectedUsers = inHomeState.selectedUsers;
        const domain = yield select((state) => state.domain);

        if (!data.response?.length) return;
        const body = data.response.map((obj) => {
            let pt = selectedUsers.find(u => u.mrn === obj.mrn)

            return {
                "patient_mrn": pt?.mrn,
                "patient_first_name": pt?.firstName,
                "patient_last_name": pt?.lastName,
                "patient_dob": pt?.dob,
                "questionnaire_name": obj.vaccineName,
                "questionnaire_responses": obj.vaccineResponses
            }
        })

        if (!body.length) return
        const response = yield call(putVaccineQuestionnaires, domain.t, body);
        if (response) {
            logAPI("MBHWeb.Saga.InHome.SetVaccineQuestionnaires", start, null);
        } else {
            logAPI("MBHWeb.Saga.InHome.SetVaccineQuestionnaires.Failure", start, null);
        }
    } catch (err) {
        console.log(err);
        logAPI("MBHWeb.Saga.InHome.SetVaccineQuestionnaires.Failure", start, null, err);
    }
}